<style lang="scss"></style>

<template>
  <div class="popup">
    <div class="popup-header">
      <p class="mb-0 fs-17 fw-b">
        <i class="fal fa-trash mr-8"></i>
        {{ $t(`${$options.name}.title`) }}
      </p>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="popup-content fs-17">
      {{ $t(`${$options.name}.description`) }}
    </div>
    <div class="popup-footer">
      <span class="btn btn-outline-primary ml-auto" @click="$emit('close')">{{
        $t('general.cancel')
      }}</span>
      <div class="btn btn-danger ml-15" @click="remove">
          <i class="fal fa-trash mr-15 my-auto"></i>
          {{ $t('general.remove') }}
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popups.admin.workspaces.remove',

  props: {
    workspaces: {
      type: Array,
      required: true,
    },
  },

  methods: {
    remove() {
      this.workspaces.forEach((workspace) => {
        this.$store.dispatch('admin/deleteWorkspaces', workspace.id).then(() => {
          this.$router.push({ name: 'admin-workspaces' });
        });
      });
      this.$emit('close');
    },
  },
};
</script>
